import { atarrayaApi } from '../../api-common'

// ============================================================================
// API ENDPOINTS
// ============================================================================
const API_ENDPOINTS = {
  FARMS: '/farms',
  USER_FARMS: '/farms/users/farms',
  FARM_BY_ID: (farmId) => `/farms/${farmId}`,
  FARM_ADDRESS: (farmId) => `/farms/${farmId}/address`,
  FARM_COSTS: '/farms/costs',
  FARM_MODULES: (farmId) => `/farms/${farmId}/modules`,
  FARM_MODULE_BY_ID: (farmId, moduleId) => `/farms/${farmId}/modules/${moduleId}`,
  FARM_BLUEWHALES: (farmId) => `/farms/${farmId}/bluewhales`,
  FARM_BLUEWHALE_BY_ID: (farmId, bluewhaleId) => `/farms/${farmId}/bluewhales/${bluewhaleId}`,
  FARM_CONTAINERS: (farmId) => `/farms/${farmId}/containers`,
  FARM_CONTAINER_BY_ID: (farmId, containerId) => `/farms/${farmId}/containers/${containerId}`,
  FARM_CONTAINER_COSTS: (farmId, containerId) => `/farms/${farmId}/containers/${containerId}/costs`,
  FARM_USERS: (farmId) => `/farms/${farmId}/users`
}

const QUERY_PARAMS = {
  WITH_ADDRESS: 'with=address',
  WITH_MODULES: 'with=modules',
  WITH_CONTAINERS: 'with=containers',
  WITH_BLUEWHALES: 'with=blueWhales',
  WITH_FARM_COST: 'with=farmCosts',
  WITH_ALL: 'with=address&with=modules&with=containers&with=blueWhales&with=farmCosts'
}

// ============================================================================
// STATE
// ============================================================================
export const state = {
  farms: [],
  simpleFarms: [],
  farmUser: [],
  modules: [],
  simpleModules: [],
  bluewhale: [],
  simpleBluewhale: [],
  containers: [],
  simpleContainers: [],
  simpleContainersByFarm: [],
  containerCost: [],
  containerStatus: [],
  usersByFarm: []
}

// ============================================================================
// MUTATIONS
// ============================================================================
export const mutations = {
  // Farm mutations
  LOAD_FARMS(state, data) {
    state.farms = data
  },

  LOAD_SIMPLE_FARMS(state, data) {
    state.simpleFarms = data
  },

  ADD_FARM(state, data) {
    state.farms.push(data)
  },

  ADD_FARM_USER(state, data) {
    state.farmUser.push(data)
  },

  UPDATE_FARM(state, data) {
    const index = state.farms.findIndex((farm) => farm.id === data.id)
    if (index >= 0) {
      Object.assign(state.farms[index], data)
    }
  },

  UPDATE_ADDRESS(state, data) {
    const index = state.farms.findIndex((farm) => farm.id === data.farmId)
    if (index >= 0) {
      Object.assign(state.farms[index].address, data)
    }
  },

  UPDATE_FARM_COST(state, data) {
    const index = state.farms.findIndex((farm) => farm.id === data.farmId)
    if (index >= 0) {
      state.farms[index].farmCost = data
    }
  },

  DELETE_FARM(state, item) {
    const index = state.farms.findIndex((farm) => farm.id === item.id)
    if (index >= 0) {
      state.farms.splice(index, 1)
    }
  },

  // Module mutations
  LOAD_MODULES(state, data) {
    state.modules = data
  },

  LOAD_SIMPLE_MODULES(state, data) {
    state.simpleModules = data
  },

  ADD_MODULE(state, data) {
    if (state.modules.modules) {
      state.modules.modules.push(data)
    } else {
      state.modules.push({ ...data })
    }
  },

  UPDATE_MODULE(state, data) {
    const targetArray = state.modules.modules || state.modules
    const index = targetArray.findIndex((module) => module.id === data.id)
    if (index >= 0) {
      Object.assign(targetArray[index], data)
    }
  },

  DELETE_MODULE(state, item) {
    const targetArray = state.modules.modules || state.modules
    const index = targetArray.findIndex((module) => module.id === item.id)
    if (index >= 0) {
      targetArray.splice(index, 1)
    }
  },

  // BlueWhale mutations
  LOAD_BLUEWHALES(state, data) {
    state.bluewhale = data
  },

  LOAD_SIMPLE_BLUEWHALES(state, data) {
    state.simpleBluewhale = data
  },

  ADD_BLUEWHALE(state, data) {
    if (state.modules.blueWhales) {
      state.modules.blueWhales.push(data)
    } else {
      state.bluewhale.push({ ...data })
    }
  },

  UPDATE_BLUEWHALE(state, data) {
    const index = state.bluewhale.findIndex((item) => item.id === data.id)
    if (index >= 0) {
      Object.assign(state.bluewhale[index], data)
    }
  },

  DELETE_BLUEWHALE(state, item) {
    if (state.modules.blueWhales) {
      const index = state.modules.blueWhales.findIndex((bw) => bw.id === item.id)
      if (index >= 0) {
        state.modules.blueWhales.splice(index, 1)
      }
    } else {
      const index = state.bluewhale.findIndex((bw) => bw.id === item.id)
      if (index >= 0) {
        state.bluewhale.splice(index, 1)
      }
    }
  },

  // Container mutations
  LOAD_CONTAINERS(state, data) {
    state.containers = data
  },

  LOAD_SIMPLE_CONTAINERS(state, data) {
    state.simpleContainers = data
  },

  LOAD_SIMPLE_CONTAINERS_BY_FARM(state, data) {
    state.simpleContainersByFarm = data
  },

  ADD_CONTAINERS(state, data) {
    state.containers.push(data)
  },

  UPDATE_CONTAINERS(state, data) {
    const index = state.containers.findIndex((container) => container.id === data.id)
    if (index >= 0) {
      Object.assign(state.containers[index], data)
    }
  },

  DELETE_CONTAINERS(state, item) {
    const index = state.containers.findIndex((container) => container.id === item.id)
    if (index >= 0) {
      state.containers.splice(index, 1)
    }
  },

  ADD_CONTAINERS_COST(state, data) {
    state.containerCost.push(data)
  },

  UPDATE_CONTAINERS_STATUS(state, data) {
    state.containerStatus.push(data)
  },

  // User mutations
  LOAD_USER_BY_FARMS(state, data) {
    state.usersByFarm = data
  },

  // Clear mutations
  CLEAR_SIMPLE_FARMS(state) {
    state.simpleFarms = []
    state.farms = []
  }
}

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================
const buildQueryString = (...params) => {
  return params.filter(Boolean).join('&')
}

const enrichContainerWithRelations = (container, modules, blueWhales) => {
  const module = modules.find((m) => m.id === container.moduleId)
  const blueWhale = blueWhales.find((bw) => bw.id === container.blueWhaleId)
  return { ...container, module, blueWhale }
}

// ============================================================================
// ACTIONS
// ============================================================================
export const actions = {
  // Farm actions
  async getFarms({ commit }) {
    try {
      const queryParams = buildQueryString(QUERY_PARAMS.WITH_ALL)
      const response = await atarrayaApi.get(`${API_ENDPOINTS.USER_FARMS}?${queryParams}`)

      commit('LOAD_FARMS', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching farms:', error)
      throw error
    }
  },

  async getSimpleFarms({ commit }) {
    try {
      const response = await atarrayaApi.get(API_ENDPOINTS.USER_FARMS)

      commit('LOAD_SIMPLE_FARMS', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching simple farms:', error)
      throw error
    }
  },

  async addFarm({ commit }, farmData) {
    try {
      const response = await atarrayaApi.post(API_ENDPOINTS.FARMS, farmData)

      commit('ADD_FARM', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error adding farm:', error)
      throw error
    }
  },

  async addFarmUser({ commit }, userData) {
    try {
      const response = await atarrayaApi.post(API_ENDPOINTS.USER_FARMS, userData)

      commit('ADD_FARM_USER', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error adding farm user:', error)
      throw error
    }
  },

  async editFarm({ commit }, farmData) {
    try {
      await atarrayaApi.patch(API_ENDPOINTS.FARM_BY_ID(farmData.id), farmData)

      commit('UPDATE_FARM', farmData)
      return farmData
    } catch (error) {
      console.error('Error editing farm:', error)
      throw error
    }
  },

  async editAddress({ commit }, addressData) {
    try {
      await atarrayaApi.patch(API_ENDPOINTS.FARM_ADDRESS(addressData.farmId), addressData)

      commit('UPDATE_ADDRESS', addressData)
      return addressData
    } catch (error) {
      console.error('Error editing address:', error)
      throw error
    }
  },

  async addFarmCost({ commit }, farmCostData) {
    try {
      const response = await atarrayaApi.post(API_ENDPOINTS.FARM_COSTS, farmCostData)
      
      commit('UPDATE_FARM_COST', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error adding farm cost:', error)
      throw error
    }
  },

  async deleteFarm({ commit }, farm) {
    try {
      await atarrayaApi.delete(API_ENDPOINTS.FARM_BY_ID(farm.id))

      commit('DELETE_FARM', farm)
      return farm
    } catch (error) {
      console.error('Error deleting farm:', error)
      throw error
    }
  },

  async getFarmsByUser({ commit }) {
    try {
      const response = await atarrayaApi.get(API_ENDPOINTS.USER_FARMS)

      commit('LOAD_FARMS', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching farms by user:', error)
      throw error
    }
  },

  // Module actions
  async getModulesContainersByFarmId({ commit }, farmId) {
    try {
      const queryParams = buildQueryString(QUERY_PARAMS.WITH_MODULES, QUERY_PARAMS.WITH_CONTAINERS, QUERY_PARAMS.WITH_BLUEWHALES, `id=${farmId}`)
      const response = await atarrayaApi.get(`${API_ENDPOINTS.FARMS}?${queryParams}`)

      const farmData = response.data.data[0]
      commit('LOAD_MODULES', farmData)
      return farmData
    } catch (error) {
      console.error('Error fetching modules containers by farm ID:', error)
      throw error
    }
  },

  async getSimpleModuleByFarmId({ commit }, farmId) {
    try {
      const response = await atarrayaApi.get(API_ENDPOINTS.FARM_MODULES(farmId))

      commit('LOAD_SIMPLE_MODULES', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching simple modules by farm ID:', error)
      throw error
    }
  },

  async addModule({ commit }, moduleData) {
    try {
      const response = await atarrayaApi.post(API_ENDPOINTS.FARM_MODULES(moduleData.farmId), moduleData)

      commit('ADD_MODULE', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error adding module:', error)
      throw error
    }
  },

  async editModule({ commit }, moduleData) {
    try {
      await atarrayaApi.patch(API_ENDPOINTS.FARM_MODULE_BY_ID(moduleData.farmId, moduleData.id), moduleData)

      commit('UPDATE_MODULE', moduleData)
      return moduleData
    } catch (error) {
      console.error('Error editing module:', error)
      throw error
    }
  },

  async deleteModule({ commit }, module) {
    try {
      await atarrayaApi.delete(API_ENDPOINTS.FARM_MODULE_BY_ID(module.farmId, module.id))

      commit('DELETE_MODULE', module)
      return module
    } catch (error) {
      console.error('Error deleting module:', error)
      throw error
    }
  },

  // BlueWhale actions
  async getBluewhale({ commit }, farmId) {
    try {
      const response = await atarrayaApi.get(`${API_ENDPOINTS.FARM_BLUEWHALES(farmId)}?${QUERY_PARAMS.WITH_CONTAINERS}`)

      commit('LOAD_BLUEWHALES', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching bluewhales:', error)
      throw error
    }
  },

  async getSimpleBluewhale({ commit }, farmId) {
    try {
      const response = await atarrayaApi.get(API_ENDPOINTS.FARM_BLUEWHALES(farmId))

      commit('LOAD_SIMPLE_BLUEWHALES', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching simple bluewhales:', error)
      throw error
    }
  },

  async addBluewhale({ commit }, bluewhaleData) {
    try {
      const response = await atarrayaApi.post(API_ENDPOINTS.FARM_BLUEWHALES(bluewhaleData.farmId), bluewhaleData)

      commit('ADD_BLUEWHALE', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error adding bluewhale:', error)
      throw error
    }
  },

  async editBluewhale({ commit }, bluewhaleData) {
    try {
      await atarrayaApi.patch(API_ENDPOINTS.FARM_BLUEWHALE_BY_ID(bluewhaleData.farmId, bluewhaleData.id), bluewhaleData)

      commit('UPDATE_BLUEWHALE', bluewhaleData)
      return bluewhaleData
    } catch (error) {
      console.error('Error editing bluewhale:', error)
      throw error
    }
  },

  async deleteBluewhale({ commit }, bluewhale) {
    try {
      await atarrayaApi.delete(API_ENDPOINTS.FARM_BLUEWHALE_BY_ID(bluewhale.farmId, bluewhale.id))

      commit('DELETE_BLUEWHALE', bluewhale)
      return bluewhale
    } catch (error) {
      console.error('Error deleting bluewhale:', error)
      throw error
    }
  },

  // Container actions
  async getContainersByFarmId({ commit }, farmId) {
    try {
      const queryParams = buildQueryString('with=farm', 'with=module', 'with=blueWhale')
      const response = await atarrayaApi.get(`${API_ENDPOINTS.FARM_CONTAINERS(farmId)}?${queryParams}`)

      commit('LOAD_CONTAINERS', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching containers by farm ID:', error)
      throw error
    }
  },

  async getContainers({ commit }) {
    try {
      const queryParams = buildQueryString(QUERY_PARAMS.WITH_ADDRESS, QUERY_PARAMS.WITH_CONTAINERS)
      const response = await atarrayaApi.get(`${API_ENDPOINTS.FARMS}?${queryParams}`)

      commit('LOAD_CONTAINERS', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching containers:', error)
      throw error
    }
  },

  async getSimpleContainers({ commit }) {
    try {
      const response = await atarrayaApi.get(`${API_ENDPOINTS.FARMS}?${QUERY_PARAMS.WITH_CONTAINERS}`)

      commit('LOAD_SIMPLE_CONTAINERS', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching simple containers:', error)
      throw error
    }
  },

  async getSimpleContainersByFarmId({ commit }, farmId) {
    try {
      const response = await atarrayaApi.get(API_ENDPOINTS.FARM_CONTAINERS(farmId))

      commit('LOAD_SIMPLE_CONTAINERS_BY_FARM', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching simple containers by farm ID:', error)
      throw error
    }
  },

  async addContainer({ commit, state }, containerData) {
    try {
      const response = await atarrayaApi.post(API_ENDPOINTS.FARM_CONTAINERS(containerData.farmId), containerData)

      const enrichedContainer = enrichContainerWithRelations(
        response.data.data,
        state.simpleModules,
        state.simpleBluewhale
      )

      commit('ADD_CONTAINERS', enrichedContainer)
      return enrichedContainer
    } catch (error) {
      console.error('Error adding container:', error)
      throw error
    }
  },

  async editContainer({ commit }, containerData) {
    try {
      await atarrayaApi.patch(API_ENDPOINTS.FARM_CONTAINER_BY_ID(containerData.farmId, containerData.id), containerData)

      commit('UPDATE_CONTAINERS', containerData)
      return containerData
    } catch (error) {
      console.error('Error editing container:', error)
      throw error
    }
  },

  async deleteContainer({ commit }, container) {
    try {
      await atarrayaApi.delete(API_ENDPOINTS.FARM_CONTAINER_BY_ID(container.farmId, container.id))

      commit('DELETE_CONTAINERS', container)
      return container
    } catch (error) {
      console.error('Error deleting container:', error)
      throw error
    }
  },

  async addContainerCost({ commit }, costData) {
    try {
      const payload = {
        costPerDay: costData.costPerDay,
        note: costData.note
      }
      const response = await atarrayaApi.post(API_ENDPOINTS.FARM_CONTAINER_COSTS(costData.farmId, costData.containerId), payload)

      commit('ADD_CONTAINERS_COST', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error adding container cost:', error)
      throw error
    }
  },

  async updateContainerStatus({ commit }, statusData) {
    try {
      const payload = { status: statusData.status }
      const response = await atarrayaApi.patch(API_ENDPOINTS.FARM_CONTAINER_BY_ID(statusData.farmId, statusData.containerId), payload)

      commit('UPDATE_CONTAINERS_STATUS', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error updating container status:', error)
      throw error
    }
  },

  // User actions
  async getUserByFarm({ commit }, farmId) {
    try {
      const response = await atarrayaApi.get(API_ENDPOINTS.FARM_USERS(farmId))

      commit('LOAD_USER_BY_FARMS', response.data.data)
      return response.data.data
    } catch (error) {
      console.error('Error fetching users by farm:', error)
      throw error
    }
  },

  // Clear actions
  clearAllFarmsData({ commit }) {
    commit('CLEAR_SIMPLE_FARMS')
  }
}

// ============================================================================
// GETTERS
// ============================================================================
export const getters = {
  // Farm getters
  farms: (state) => state.farms,
  simpleFarms: (state) => state.simpleFarms,
  farmUser: (state) => state.farmUser,

  // Module getters
  modules: (state) => state.modules,
  simpleModules: (state) => state.simpleModules,

  // BlueWhale getters
  bluewhale: (state) => state.bluewhale,
  simpleBluewhale: (state) => state.simpleBluewhale,

  // Container getters
  containers: (state) => state.containers,
  simpleContainers: (state) => state.simpleContainers,
  simpleContainersByFarm: (state) => state.simpleContainersByFarm,
  containerCost: (state) => state.containerCost,
  containerStatus: (state) => state.containerStatus,

  // User getters
  usersByFarm: (state) => state.usersByFarm,

  // Computed getters
  farmCount: (state) => state.farms.length,
  activeFarms: (state) => state.farms.filter(farm => farm.status === 'active'),
  farmById: (state) => (id) => state.farms.find(farm => farm.id === id)
}